import type { IconNode } from '../types';

/**
 * @name barn
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjIgMTJIMmwyLTYgOC00IDggNFoiIC8+CiAgPHJlY3Qgd2lkdGg9IjQiIGhlaWdodD0iNCIgeD0iMTAiIHk9IjgiIC8+CiAgPHBhdGggZD0ibTcgMjIgMTAtMTB2MTBMNyAxMloiIC8+CiAgPHBhdGggZD0iTTIxIDEydjhhMiAyIDAgMCAxLTIgMkg1YTIgMiAwIDAgMS0yLTJ2LTgiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/barn
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const barn: IconNode = [
  ['path', { d: 'M22 12H2l2-6 8-4 8 4Z', key: '1g52nw' }],
  ['rect', { width: '4', height: '4', x: '10', y: '8', key: '1f1gqv' }],
  ['path', { d: 'm7 22 10-10v10L7 12Z', key: 'jw2rko' }],
  ['path', { d: 'M21 12v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-8', key: 'woe9fu' }],
];

export default barn;
